export function deepSearch(object, key) {
  if (!object) return null;

  if (key instanceof RegExp) {
    const objectKeys = Object.keys(object);
    const match = objectKeys.find((k) => key.test(k));

    if (match) {
      return object[match];
    }
  }

  if (object.hasOwnProperty(key)) return object[key];

  for (const objectKey in object) {
    if (typeof object[objectKey] === "object") {
      const o = deepSearch(object[objectKey], key);
      if (o !== null) return o;
    }
  }
  return null;
}
